import { useMutation, useQueryClient } from '@tanstack/react-query';
import { menuApi } from '../api/menuApi';

/**
 * DELETE /api/eraf/menus/{id} — 메뉴 소프트 삭제
 * 성공 시 tree / flat / detail 캐시 무효화
 */
export function useDeleteMenu() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => menuApi.delete(id),
    onSuccess: (_data, id) => {
      void qc.invalidateQueries({ queryKey: ['menu-management', 'tree'] });
      void qc.invalidateQueries({ queryKey: ['menu-management', 'flat'] });
      void qc.removeQueries({ queryKey: ['menu-management', 'detail', id] });
      void qc.invalidateQueries({ queryKey: ['menu-management', 'me'] });
      void qc.invalidateQueries({ queryKey: ['catalog'] });
    },
  });
}
